<template>
  <section>
    <div v-if="loading">

      <!-- List -->
      <div class="overflow-auto">
      <table class="table table-report -mt-2">
        <thead>
            <tr>
                <th class="whitespace-no-wrap">NOMBRE</th>
                <th class="text-center whitespace-no-wrap"># TAREAS</th>
                  <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
        </thead>
        <tbody>
          <tr class="intro-x" v-for="email in emails">
              <td>
                  <div class="font-medium whitespace-no-wrap">{{email.user_created_name }}</div>
              </td>
              <td>
                <div class="text-center text-gray-600 text-xs whitespace-no-wrap">{{ email.total }}</div>
              </td>
              <td>
                  <div class="text-center text-gray-600 text-xs whitespace-no-wrap cursor-pointer" @click="finishEmails(email.user_created.id)">
                    Finalizar todas
                  </div>
              </td>
          </tr>
        </tbody>
      </table>
      </div>
      <!-- END: List -->

    </div>

    <app-loading v-else />

  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminEmailWithoutFinish',
  data () {
    return {
      loading: false,
      emails: []
    }
  },
  async beforeMount () {
    try {
      await this.getEmails()
    } catch (error) {} finally {
        this.loading = true
    }
  },
  methods: {
    ...mapActions(['get']),
    async getEmails() {
      const { list } = await this.get(
        `/emails-without-finish`
      )
      this.emails = list
    },
    async finishEmails(id) {
      var url = 'finish-emails-user/'+id
      await this.get(url)
      setTimeout(() => {
      location.reload()
      }, "1000");
    }
  },
  components: {
    appLoading: Loading
  },
}
</script>



// WEBPACK FOOTER //
// EmailWithoutFinish.vue?475d3905